module.exports = __webpack_public_path__ + "static/img/white-logo.43ee6dd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/white-logo.svg
// module id = Ubww
// module chunks = 1